const survey_pt = require('./survey.json')
export default survey_pt